import React, { useEffect, useState } from "react";
import PendingApprovalsTable from "./TotalAnnouncementsTable";
import StatusDistribution from "./StatusDistribution";
import RecentActivity from "./RecentActivity";
import ActiveUsers from "./ActiveUsers";
import PendingAnnouncements from "./PendingAnnouncements";
import QuickActions from "./QuickActions";
import TotalAnnouncements from "./TotalAnnouncements";
import ActiveApprovers from "./ActiveApprovers";
import Approved from "./Approved";
import Rejected from "./Rejected";
import toastr from "toastr";
import translations from "../../translation";

const Dashboard = ({ language = "en" }) => {
  const [cardsData, setCardsData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem("user"));

  const translate = (key) => translations[language]?.[key] || key;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const response = await fetch(`${process.env.REACT_APP_CHECK_USER_API}/api/admin/analytics`, {
        method: "GET",
      });

      if (!response.ok) {
        toastr.error(translate("apiFetchError"));
        return;
      }

      const data = await response.json();
      setCardsData(data.analytics || {});
    } catch (error) {
      console.error("Error fetching data: ", error);
      toastr.error(translate("apiError"));
    } finally {
      setIsLoading(false); // End loading
    }
  };

  if (isLoading) {
    return (
      <div className="w-full text-center py-8">
        <span className="text-gray-500">{translate("loadingDashboard")}</span>
      </div>
    );
  }

  if (!cardsData) {
    return (
      <div className="w-full text-center py-8">
        <span className="text-gray-500">{translate("noDataAvailable")}</span>
      </div>
    );
  }

  return (
    <main className="w-full px-4 sm:px-6 lg:px-8 py-8">
      {/* Top Cards */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8">
        <TotalAnnouncements
          count={cardsData.totalAnnouncements || 0}
          label={translate("totalAnnouncements")}
          language={language}
        />
        <ActiveUsers
          count={cardsData.totalUsers || 0}
          label={translate("activeUsers")}
          language={language}
        />
        <PendingAnnouncements
          count={cardsData.totalPendingAnnouncements || 0}
          label={translate("pendingAnnouncements")}
          language={language}
        />
      </div>

      {/* Second Row of Cards */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-8">
        <ActiveApprovers
          count={cardsData.totalApprovers || 0}
          label={translate("activeApprovers")}
          language={language}
        />
        <Approved
          count={cardsData.totalApprovedAnnouncements || 0}
          label={translate("approvedAnnouncements")}
          language={language}
        />
        <Rejected
          count={cardsData.totalRejectedAnnouncements || 0}
          label={translate("rejectedAnnouncements")}
          language={language}
        />
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
          <PendingApprovalsTable label={translate("pendingApprovalsTable")} language={language}/>
        </div>
        <div className="lg:col-span-1">
          <StatusDistribution
            content={cardsData}
            label={translate("statusDistribution")}
            language={language}
          />
          <RecentActivity label={translate("recentActivity")} language={language}/>
        </div>
      </div>
    </main>
  );
};

export default Dashboard;
